import axios from "axios";
import StoreManagement from "./StoreManagement";
import AuthService from "./AuthService";

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true
});

HTTP.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    const TOKEN = StoreManagement.getToken();
    if (TOKEN) {
      config.headers.Authorization = TOKEN;
    }
    return config;
  },
  function(error) {
    // Do something with request error'
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    let respError = { error };
    if (respError.error.response.status === 401) {
      alert("Sua sessão expirou. Faça login novamente.");
      AuthService.logout();
    }
    return Promise.reject(error);
  }
);
